export type LocalizedLinks = {
  en: string;
  zh: string;
};

export const SportBistroUrl: LocalizedLinks = {
  en: "https://book.bistrochat.com/sportsbistro-saisha?l=en_US",
  zh: "https://book.bistrochat.com/sportsbistro-saisha?l=zh_TW",
};

export const DreamlandUrl: LocalizedLinks = {
  en: "https://yiuwing.odoo.com/appointment/3",
  zh: "https://yiuwing.odoo.com/appointment/3",
};
